import React, { useState } from "react";
import { useAuth } from "../auth";
import { formatApiErrorDetail } from "../api";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit} data-testid="login-form">
        <h1>Referral Lite</h1>
        <p className="muted">Admin sign in</p>
        {error && (
          <div className="alert" data-testid="login-error">
            {error}
          </div>
        )}
        <label>Email</label>
        <input
          type="email"
          value={email}
          data-testid="login-email"
          onChange={(e) => setEmail(e.target.value)}
          placeholder="admin@example.com"
          required
        />
        <label>Password</label>
        <input
          type="password"
          value={password}
          data-testid="login-password"
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          required
        />
        <button className="btn btn-primary" type="submit" data-testid="login-submit" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
